import React from "react";
import { MapPin, Mail, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function OurClubDetails() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const contactDetails = [{
    icon: MapPin,
    label: "GLOBAL OPERATIONS",
    value: "101 Silicon Way, Palo Alto, CA 94301",
    link: "https://maps.google.com",
    isExternal: true
  }, {
    icon: Mail,
    label: "ACCESS INQUIRY",
    value: "intelligence@n2n-capital.com",
    link: "mailto:intelligence@n2n-capital.com",
    isExternal: false
  }, {
    icon: Phone,
    label: "NETWORK LINE",
    value: "+1 (650) 555-0198",
    link: "tel:+16505550198",
    isExternal: false
  }];
  return;
}